// extracted by mini-css-extract-plugin
module.exports = {"required-asterisk":"style_required-asterisk__Bp_qI","required-field":"style_required-field__DHBwc","read-only-value":"style_read-only-value__0QuCY"};